<template>
  <div class="animated fadeIn sources--sources-list">
    <b-row>
      <b-col v-if="checkClaim(CAN_ADD_POS) && showCreatePO">
        <div class="tools">
          <b-button id="tooltip-target-1" class="fa fa-info" size="sm" variant="info"></b-button>
          <b-tooltip target="tooltip-target-1" triggers="hover">
            <span><b>Select</b> your source to create a PO. Ensure the Sales Order is <b>authorized</b> and a Sales order line has a <b>backorder</b></span>  
          </b-tooltip>     
          <b-button
            size="sm"
            variant="primary"
            @click="$emit('on-create-po')"
            :disabled="isDisabledCreatePO || !selectedRowItemId"
          >Create Purchase Order</b-button>          
        </div>
      </b-col>
      <b-col>
        <div class="d-flex justify-content-end mb-2">
          <b-button
            size="sm"
            variant="primary"
            :disabled="!selectedRowItemId"
            @click="setPreferredSource"
          >{{ (selectedIsPreferred) ? 'Unprefer' : 'Make Preferred' }}</b-button>
        </div>
      </b-col>
    </b-row>
    <grid-component
        isResizable
        isReorderable
        :gridId="gridValue"
        :itemData="itemData"
        :navigationField="'sourceId'"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="handleRowClick"
      />
    <offer-form
      :modalId="'source-offer-form-modal'"
      :companyModalId="'source-company-modal'"
      :partId="partIdOnForm"
      :lineId="lineIdOnForm"
      :offerId="offerIdOnForm"
      :companyId="companyIdOnForm"
      @onCloseModal="$emit('close-offer-form', $event)"
      @updated-source="loadSources" />
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import GridSettings from '@/shared/components/GridSettings';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import { GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import sourcesFields from './fields';
import GridComponent from '@/shared/components/GridComponent';
import OfferForm from '@/shared/components/Offers/components/AddOffer';
//@todo need to implement On order filtering when backend finish this functionality

export default {
  components: {
    GridSettings,
    GridComponent,
    OfferForm
  },
  computed: {
    ...mapState('quoteLineSources', [
      'sourcesList',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridValue);
    },
    itemData() {
      let data = (this.showPreferredOnly) ? this.sourcesList.filter(source => source.isPreferred == true) : this.sourcesList;

      return data ? data.map((source) => ({ ...source, selected: source.id === this.selectedRowItemId })) : [];
    },
    gridValue() {
      return this.gridId || GRID_ID.QUOTE_LINES_SOURCE;
    }
  },
  props: {
    quoteLineId: [Number, String],
    gridId: [String],
    partId: [Number, String],
    showPreferredOnly: [Boolean],
    showCreatePO: [Boolean],
    isDisabledCreatePO: [Boolean]
  },
  data() {
    return {
      prepareColumnsData,
      fields: sourcesFields,
      selectedIsPreferred: false,
      selectedRowItemId: 0,
      selectedItemId: 0,
      partIdOnForm: 0,
      offerIdOnForm: 0,
      lineIdOnForm: 0,
      companyIdOnForm: 0,
      sourceSelected: {}
    };
  },
  watch: {
    quoteLineId: function() {
      if (this.quoteLineId > 0) {
        this.loadSources();
      } else {
        this.setItem({ resource:'sourcesList', payload: []});
      }
    },
  },
  methods: {
    ...mapActions('quoteLineSources', [
      'getSourcesForQuoteLine',
      'setAsPrefer',
      'deleteSource',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('quoteLineSources', ['setItem']),
    handleRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.selectedIsPreferred = row.dataItem.isPreferred;
      this.$emit('selected', row.dataItem);
    },
    async loadSources() {
      if(this.quoteLineId) {
        await this.getSourcesForQuoteLine(this.quoteLineId);
        this.$emit('onSourcesLoad');
      } else {
        /*this.clearSources();*/
        this.setItem({ resource:'sourcesList', payload: []});
      }
    },
    async setPreferredSource() {
      await this.setAsPrefer(this.selectedRowItemId).then(() => {
        this.selectedRowItemId = 0;
      });

      this.$emit('onChangeSource');
    },
    onEdit: function(item) {
      switch(item.source)
      {
        case "Offer":
          this.partIdOnForm = item.partId;
          this.lineIdOnForm = item.requirementLineId;
          this.companyIdOnForm = item.vendorId;
          this.offerIdOnForm = item.vrfpLineId;
          this.$bvModal.show('source-offer-form-modal');
          break;

        case "Inventory":
          let routeInventory = this.$router.resolve({
            name: 'inventory.partDetails',
            params: { id: item.inventoryId },
          });
          window.open(routeInventory.href, '_blank');
          break;

        case "OnOrder":
          let routePO = this.$router.resolve({
            name: 'purchaseorders.edit',
            params: { id: item.purchaseOrderId },
          });
          window.open(routePO.href, '_blank');
          break;
      }

    },
    async onDelete(source) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete source?'});
      if (deleteConfirmed) {
        await this.deleteSource(source.id).then(() => this.loadSources());
        this.$snotify.success('Source Deleted', 'Quote Line Source');
        this.$emit('onChangeSource');
      }
    },
  },
  mounted() {
    this.loadSources();
  },
};
</script>

<style lang="scss">
.sources {
  &--sources-list {
    table td {
      cursor: pointer;
    }
  }
}
.parts-grid {
  height: auto !important;
}
.add-to-sources {
  margin-top: 0.5em;
  margin-bottom: 1em;
}
</style>
